import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionTwoImagesVerticalBody,
    SectionTwoImagesVerticalDetails,
} from "types/api/blocks/sectionTwoImagesVertical";

function useSectionTwoImagesVerticalApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionTwoImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionTwoImagesVerticalDetails> => {
        return get<PathParamsWithId, undefined, SectionTwoImagesVerticalDetails>({
            url: "/blocks/section-two-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionTwoImagesVertical = React.useCallback((body: SectionTwoImagesVerticalBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionTwoImagesVerticalBody, null>({
            url: "/blocks/section-two-images-vertical",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionTwoImagesVertical = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-two-images-vertical/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionTwoImagesVertical,
        saveSectionTwoImagesVertical,
        deleteSectionTwoImagesVertical
    };
}

export default useSectionTwoImagesVerticalApi;